<template>
    <div>
        <b-row>
            <b-col cols="12">
                <div class="solution-steps">
                    <b-tabs pills content-class="mt-4" align="center">
                        <b-tab title="Calculate" @click="emitEvent('reset-shows-props', 'reset-select-product')">
                        </b-tab>
                        <b-tab title="Bank" :active="showPersonalLoanBank" @click="emitEvent('show-personal-loan-bank')">
                            <PersonalLoanBankSelection />
                        </b-tab>
                        <b-tab title="Personal Loan" :active="showPersonalLoanSelection" @click="emitEvent('show-personal-loan-selection')">
                            <PersonalLoanSelection />
                        </b-tab>
                        <b-tab title="Summary" :active="showPersonalLoanSummary" @click="emitEvent('show-personal-loan-summary')">
                            <PersonalLoanSummary />
                        </b-tab>
                    </b-tabs>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { Tabs, TabPane } from 'element-ui'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import PersonalLoanBankSelection from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/PersonalLoan/PersonalLoanBankSelection'
import PersonalLoanSelection from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/PersonalLoan/PersonalLoanSelection'
import PersonalLoanSummary from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/PersonalLoan/PersonalLoanSummary'

export default {
    props: {
        showPersonalLoanBank: Boolean,
        showPersonalLoanSelection: Boolean,
        showPersonalLoanSummary: Boolean,
    },
    components: {
        PersonalLoanBankSelection,
        PersonalLoanSelection,
        PersonalLoanSummary,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
    },
    methods: {
        emitEvent(...eventNames) {
            eventNames.forEach(eventName => {
                solutionEventBus.$emit(eventName)
            })
        }
    },
}
</script>